<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('events-panel')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New Event</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="title"
        >
        </base-input>
        <base-input
          alternative
          class="mb-3"
          name="URL"
          :rules="{ required: true }"
          placeholder="Enter URL Text"
          v-model="linktext"
        >
        </base-input>

        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        (Dimensions should H-700, W-900)
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
        <img v-if="image" :src="image" ref="cover" />
        <!--  <quill-editor
          v-model="body"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->
        <div class="py-4 customboxed">
          <p class="mb-1">Enter URL</p>
          <base-input
            class="mb-3"
            name="URL"
            placeholder="Add URL for Registration Form / Gallery"
            v-model="link"
          >
          </base-input>
        </div>

        <!-- <b-form-group id="input-group-3" label="Tags:" label-for="input-3">
          <b-form-select id="input-3" v-model="selectedtag" required>
            <b-form-select-option :value="null" disabled
              >-- Please select an Tags --</b-form-select-option
            >
            <b-form-select-option
              v-for="(tag, indexOpt) in tags"
              :value="tag._id"
              :key="indexOpt"
              >{{ tag.name }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group> -->
        <div class="flex">
          <div class="my-4 w-1/2">
            <!-- <base-input>
            <flat-picker
              placeholder="Select Date"
              v-model="selectdate"
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              required
              :config="{ allowInput: true }"
              class="form-control datepicker"
            >
            </flat-picker>
          </base-input> -->

            <b-form-group label="Date:">
              <date-picker
                slot-scope="{ focus, blur }"
                @on-open="focus"
                @on-close="blur"
                required
                :config="{ allowInput: true }"
                placeholder="Select Date"
                v-model="selectdate"
                class="w-full"
                valueType="format"
              >
              </date-picker>
            </b-form-group>
          </div>
          <div class="ml-12 w-1/2 my-4">
            <b-form-group label="Time:">
              <date-picker
                v-model="selecttime"
                format="HH:mm"
                value-type="format"
                type="time"
                class="w-full"
                :config="configdateTimePicker"
                placeholder="HH:mm"
              >
              </date-picker>
            </b-form-group>
            <!-- <base-input>
            <flat-picker
              :config="configdateTimePicker"
              v-model="selecttime"
              name="Time"
              required
              class="w-full border p-2 rounded-lg"
              placeholder="Choose time"
              @click="tConvert(selecttime)"
            />
          </base-input> -->

            <!-- <b-form-timepicker
            id="timepicker-lg"
            size="sm"
            locale="en"
            class="w-full border p-2 rounded-lg"
            name="Time"
            v-model="selecttime"
            required
          >
          </b-form-timepicker> -->
          </div>
        </div>
        <div class="mb-2">
          <b-form-group label="Tags:">
            <div class="md:flex justify-between items-center">
              <b-form-select v-model="selectedtag" required class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="selectedSeg" class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="selectedUsers" class="">
                <b-form-select-option :value="null" disabled>
                  Select {{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              >
            </div>
          </b-form-group>
        </div>
        <div class="mb-2">
          <b-form-checkbox id="checkbox-1" v-model="onlyCorporateEvent">
            <p>
              <strong>
                <p class="col-blk">
                  Click here to add event to Corporate Event.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>

        <div class="mb-2">
          <b-form-checkbox
            id="checkbox-2"
            v-model="onlyRegistered"
            :disabled="onlyCorporateEvent"
          >
            <p>
              <strong>
                <p class="col-blk">
                  Click here to restrict access to this event for registered
                  users only.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <!-- <div class="mb-2">
          <b-form-checkbox id="checkbox-3" v-model="isSelected">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this event on campaign.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div> -->
        <div class="mb-2 w-1/3">
          <label for="campaign">Campaigns:</label>
          <multiselect
            v-model="selectedCampaigns"
            :options="getCampaignOptions()"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :preselect-first="false"
            placeholder="Select Campaign"
            track-by="value"
            label="label"
          ></multiselect>
        </div>
        <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="false"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
            :disabled="!onlyRegistered ? true : false || onlyCorporateEvent"
          >
          </multiselect>
        </div>

        <!-- <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaKeyword"
            >
            </base-input>
          </div>
        </div> -->
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  components: {
    FileUploader,

    DatePicker,
  },
  data() {
    return {
      title: "",
      image: null,
      coverImage: null,
      startDate: "",
      body: "",
      editorOption: {
        theme: "snow",
      },
      filter1: [],
      filter2: [],
      filter3: [],
      Ctags: [],
      selectedCampaigns: [],
      campaignOptions: [],
      link: "",
      linktext: "",
      selectedtag: null,
      selectedUsers: null,
      selectedSeg: null,
      selectdate: "",
      selecttime: "",
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
      },
      isFeatured: false,
      imageErr: false,
      msg: {},
      selectedMembership: null,
      membershipFilter: [],
      onlyRegistered: false,
      isSelected: false,
      onlyCorporateEvent: false,
      // metaTitle: "",
      // metaKeyword: "",
      // metaDesc: "",
      // metaCanonicalTag: "",
    };
  },
  computed: {
    ...mapState("cms", {
      filtertags: "filtertags",
      filters: "filters",
      selectedpagecategory: "selectedpagecategory",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
    ...mapState("campaignPageBanner", { campaignHome: "campaignHome" }),
    campaignHome() {
      return this.$store.state.campaignPageBanner.campaignHome || {};
    },
  },
  methods: {
    getCampaignOptions() {
      return this.campaignHome && this.campaignHome.result
        ? this.campaignHome.result.map((campaign) => ({
            label: campaign.heading,
            value: campaign._id,
          }))
        : [];
    },
    isPastDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (image.type.includes("video")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    tConvert(selecttime) {
      selecttime = selecttime
        .toString()
        .match(/^([01]\2[0-3])(:)([0-5]\d)?$/) || [selecttime];
      if (selecttime.length > 1) {
        selecttime = selecttime.slice(1);
        selecttime[5] = +selecttime[0] < 12 ? "AM" : "PM";
        selecttime[0] + (selecttime[0] % 12) || 12;
      }
      // var suffix = selecttime >= 12 ? "PM" : "AM";
      // var selecttime = ((selecttime + 11) % 12) + 1 + suffix;
      return selecttime.join("");
    },
    async onSubmit() {
      if (!this.onlyRegistered) {
        this.selectedMembership = null;
      }
      let FormData = require("form-data");
      let data = new FormData();
      this.Ctags.push(this.selectedtag, this.selectedSeg, this.selectedUsers);
      if (this.onlyCorporateEvent) {
        // const payload = new FormData();
        // payload.append("title", this.title);
        // payload.append("description", this.linktext);

        // payload.append("bannerImage", this.coverImage);
        // payload.append(
        //   "eventDate",
        //   new Date(new Date(this.selectdate).setHours(0, 0, 0))
        // );
        // // payload.append("eventDate", this.selectdate);
        // payload.append("eventTime", this.selecttime);

        // let result = await this.$store.dispatch(
        //   "ffc/addCorporateEvents",
        //   payload
        // );
        // console.log(result, "RESULLT");
        // if (result.data) {
        data.append("onlyCorporateEvent", true);
        // }
      }
      data.append("type", "single");
      data.append("title", this.title);
      data.append("subTitle", "");
      data.append("media", this.coverImage);
      data.append("html", this.body);
      data.append("tags", JSON.stringify(_.uniq(this.Ctags)));
      data.append("linktext", this.linktext);
      data.append("date", this.selectdate);
      data.append("link", this.link);
      data.append("time", this.selecttime);
      data.append("pageCategory", this.selectedpagecategory.id);
      data.append("isFeatured", this.isFeatured);
      // data.append("isSelected", this.isSelected);
      data.append(
        "selectedCampaigns",
        this.selectedCampaigns.map((campaign) => campaign.value)
      );

      // data.append("metaKeyword", this.metaKeyword);
      // data.append("metaCanonicalTag", this.metaCanonicalTag);
      // data.append("metaDesc", this.metaDesc);
      // data.append("metaTitle", this.metaTitle);

      data.append("memberships", JSON.stringify(this.selectedMembership));
      if (this.selectedMembership !== null) {
        data.append("onlySubscribed", true);
        data.append("onlyRegistered", true);
      } else {
        data.append("onlyRegistered", this.onlyRegistered);
        data.append("onlySubscribed", false);
      }

      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const eventdata = await this.$store.dispatch("cms/addPage", data);
        if (eventdata.code == 200) {
          this.$router.push({ name: "events-panel" });
          this.$swal.fire({
            text: "Event successfully created",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }

        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async gettagsbycategory() {
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      this.membershipFilter = this.get_all_membership.filter((membership) => {
        if (
          membership.name.toLowerCase() !== "visitor" &&
          membership.name.toLowerCase() !== "registered"
        ) {
          return true;
        }
        return false;
      });
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.gettagsbycategory();
  },
  watch: {
    membershipFilter() {
      if (this.blog_data.memberships && this.blog_data.memberships.length > 0) {
        this.selectedMembership = this.membershipFilter.filter((membership) => {
          let data = this.blog_data.memberships.find(
            (member) => member._id === membership._id
          );
          // return this.blog_data.memberships.includes(membership._id);
          return data;
        });
        // console.log(this.selectedMembership);
      }
    },
    selectdate(value) {
      console.log(
        new Date(new Date(value).setHours(0, 0, 0)),
        "CONVERTED DATAE"
      );
    },
  },
};
</script>
<style scoped>
.w-full {
  width: 100% !important;
}
.col-blk {
  color: #777777;
}
</style>
